import { Backdrop, Box, Drawer, IconButton, Paper } from '@mui/material'
import React, { FC, useState } from 'react'
import { connect } from 'react-redux'
import { actions } from '../../redux/appReducer'
import { StateType } from '../../redux/store'
import { Shift } from '../common/Helpers'
import PricingSidebar from './PricingSidebar'
import CloseIcon from '@mui/icons-material/Close'
import ArrowUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDownIcon from '@mui/icons-material/ArrowDropDown'

interface IProps {
    isSidebarOpen: boolean

    setIsSidebarOpen(value: boolean): void
    setSidebarHeight(value: number): void
}

const SlidingSidebar: FC<IProps> = props => {
    const [expanded, setExpanded] = useState(false)

    const onCloseClick = () => {
        props.setIsSidebarOpen(false)
    }

    const onArrowClick = () => {
        if (expanded) {
            props.setSidebarHeight(window.innerHeight * .5 - 48)
            setExpanded(false)
        }
        else {
            props.setSidebarHeight(window.innerHeight - 48)
            setExpanded(true)
        }
    }

    return (
        <Drawer
            anchor='bottom'
            open={props.isSidebarOpen}
            BackdropComponent={() => <Backdrop open={true} invisible={true} onClick={() => { props.setIsSidebarOpen(false) }} />}
            style={{ opacity: .7 }}
        >
            <Box>
                <Paper style={{ display: 'flex' }}>
                    <Shift />
                    <IconButton onClick={onArrowClick}>
                        {!expanded &&
                            <ArrowUpIcon />
                        }
                        {expanded &&
                            <ArrowDownIcon />
                        }
                    </IconButton>
                    <IconButton onClick={onCloseClick}>
                        <CloseIcon />
                    </IconButton>
                </Paper>
                <PricingSidebar />
            </Box>
        </Drawer>
    )
}

const mapStateToProps = (state: StateType) => ({
    isSidebarOpen: state.appReducer.isSidebarOpen
})

export default connect(mapStateToProps, {
    setIsSidebarOpen: actions.setIsSidebarOpen,
    setSidebarHeight: actions.setSidebarHeight
})(SlidingSidebar)